const FIXED_CLASS = 'fixed';
const MAIN_MENU_ID = 'main-menu';
const MOBILE_CARD_ID = 'mobile-main-menu-card';
const MOBILE_CLOSE_TRIGGER_SELECTOR = '.mobile-main-menu-close-trigger';
const MOBILE_OPEN_TRIGGER_SELECTOR = '.mobile-main-menu-open-trigger';
const OPEN_CLASS = 'open';

export const SCROLL_TOP_TRIGGER_POSITION = 84;

export default class MainMenuManager {
  constructor() {
    this._mainMenu = document.getElementById(MAIN_MENU_ID);
    this._mobileMainMenuCard = document.getElementById(MOBILE_CARD_ID);

    const openTriggers = document.querySelectorAll(MOBILE_OPEN_TRIGGER_SELECTOR);
    openTriggers.forEach(el => {
      el.addEventListener('click', this.openMobileMenu.bind(this));
    });

    const clseTriggers = document.querySelectorAll(MOBILE_CLOSE_TRIGGER_SELECTOR);
    clseTriggers.forEach(el => {
      el.addEventListener('click', this.closeMobileMenu.bind(this));
    });

    window.addEventListener('scroll', this.scrollPerformed.bind(this));
    this.scrollPerformed();
  }

  closeMobileMenu() {
    this._mobileMainMenuCard.classList.remove(OPEN_CLASS);
  }

  openMobileMenu() {
    this._mobileMainMenuCard.classList.add(OPEN_CLASS);
  }

  scrollPerformed() {
    const isFixed = (window.scrollY > SCROLL_TOP_TRIGGER_POSITION);
    this._mainMenu.classList.toggle(FIXED_CLASS, isFixed);
  }
}
